import { render, staticRenderFns } from "./EditPassword.vue?vue&type=template&id=13fa75c8&"
import script from "./EditPassword.vue?vue&type=script&lang=js&"
export * from "./EditPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports